module.exports = __webpack_public_path__ + "media/images/flags/1x1/flk-b8b4663973f0a6a2fcb368d58be6337d.svg";